<template>
    <div class="einzelproben">
        <h5>Neue Einzelprobe anlegen</h5>
        <b-form>
            <b-input-group prepend="Einzelproben Damen" :size="size">
                <b-select :options="probenstammSelect" v-model="form.id_da"></b-select>
                <b-input placeholder="x = 1 Pp. (Da)" v-model="form.da_faktor" />
            </b-input-group>
            <b-input-group prepend="Einzelproben Herren" :size="size">
                <b-select :options="probenstammSelect" v-model="form.id_he"></b-select>
                <b-input placeholder="x = 1 Pp. (He)" v-model="form.he_faktor" />
                <b-input-group-append>
                    <b-button @click="addEinzelprobe">Anlegen</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-form>
        <hr />
        <h5>Zugeordnete Einzelproben</h5>
        <Table
            bordered
            striped
            small
            :fields="fields"
            :items="items"
            :isBusy="busy"
            busyText="Lädt Einzelproben..."
            emptyText="Keine Einzelproben gefunden"
        >
            <template v-slot:actions="{row: row}">
                <b-button
                    :size="size"
                    @click="deleteEinzelprobe(row)"
                    variant="link"
                    class="text-danger mv-table-action-btn"
                >Löschen</b-button>
            </template>
        </Table>
    </div>
</template>

<script>
import shortid from "shortid";
import Size from "@/mixins/Size/Size";
import Table from "@/components/Table/Table";
import { ApiFactory } from "@/api/ApiFactory.js";

const ProbenStammdatenApi = ApiFactory.get("proben_stammdaten");

export default {
    name: "Einzelproben",
    mixins: [Size],
    components: {
        Table
    },
    props: ["probe", "probenstamm"],
    data() {
        return {
            fields: [
                {
                    key: "werk_da",
                    label: "Einzelproben Damen"
                },
                {
                    key: "da_faktor",
                    label: "x = 1 Zp. (Da)"
                },
                {
                    key: "werk_he",
                    label: "Einzelproben Herren"
                },
                {
                    key: "he_faktor",
                    label: "x = 1 Zp. (He)"
                },
                {
                    key: "actions",
                    label: "Funktionen"
                }
            ],
            busy: false,
            items: [],
            form: {
                id: null,
                id_da: null,
                da_faktor: null,
                id_he: null,
                he_faktor: null,
                werk_da: "",
                werk_he: ""
            }
        };
    },
    computed: {
        probenstammSelect() {
            const probenstamm = this.probenstamm.map(probe => {
                return {
                    text: probe.werk + " - " + probe.ablaufdatum,
                    value: probe.id
                };
            });
            return probenstamm;
        }
    },
    created() {
        this.fetch();
    },
    watch: {
        items: {
            handler(val) {
                this.$emit("update", val);
            },
            deep: true
        }
    },
    methods: {
        async fetch() {
            if (this.probe) {
                this.busy = true;
                const response = await ProbenStammdatenApi.getEinzelproben(
                    this.probe.id
                );
                if (response.ok) {
                    var items = response.json.collection;
                    if (items) {
                        this.items = items;
                    } else {
                        this.items = [];
                    }
                }
                this.busy = false;
            }
        },
        addEinzelprobe() {
            const form = this.form;
            form.id = "new_" + String(shortid.generate());
            form.werk_da = this.probenstamm
                .filter(item => item.id === form.id_da)
                .map(item => item.werk)
                .pop();
            form.werk_he = this.probenstamm
                .filter(item => item.id === form.id_he)
                .map(item => item.werk)
                .pop();

            this.items.push(this.form);
            this.form = {
                id: null,
                id_da: null,
                da_faktor: null,
                id_he: null,
                he_faktor: null,
                werk_da: "",
                werk_he: ""
            };
        },
        deleteEinzelprobe(value) {
            this.items = this.items.filter(item => item.id !== value.id);
        }
    }
};
</script>